import { processEmailFields } from "customHooks/useCompleoReactHookForm/components/FormMainHelper";
import _ from "lodash";

export const getHandleWorkflowSubmit = (fnToRun: any) => {
    const HandleSubmit = async (values: any) => {
        try {
            const companyId = values.companyId;
            const clonedValues = _.cloneDeep(values);
            const stages = values?.stages || [];
            for (let index = 0; index < stages.length; index++) {
                // Process email templates in stages
                if (stages[index].emailTemplate) {
                    clonedValues.stages[index].emailTemplate = (
                        await processEmailFields({
                            emailTemplate: stages[index].emailTemplate,
                            companyId: companyId
                        })
                    ).emailTemplate;
                }
            }

            return fnToRun(clonedValues);
        } catch (ex) {
            return ex.response;
        }
    };
    return HandleSubmit;
};
